import clsx from 'clsx';
import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import type { ProductAlternative } from '../../../@sprinx/knihovka-types';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import ProductDetailAlternativeRow from './ProductDetailAlternativeRow';

export interface ProductDetailAlternativesProps extends StandardDivProps<ProductDetailAlternativesClassKey> {
  productAlternatives: ProductAlternative[] | undefined;
  sectionName: string;
}

export type ProductDetailAlternativesClassKey = 'root' | 'itemRow' | 'name' | 'higlight';

const themeSettings = { name: 'ProductDetailAlternatives' };
const useStyles = makeStyles(
  () =>
    createStyles<ProductDetailAlternativesClassKey, {}>({
      root: {},
      itemRow: {},
      name: {
        '& > h1': { fontSize: 18 },
      },
      higlight: {
        color: 'red',
      },
    }),
  themeSettings,
);

const ProductDetailAlternatives = React.forwardRef<HTMLDivElement, ProductDetailAlternativesProps>(
  ({ className, classes: pClasses, sectionName, productAlternatives }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <h2>{sectionName}</h2>
        {productAlternatives && productAlternatives.length ? (
          <ul>
            {productAlternatives.map((v, idx) => (
              <li key={idx}>
                <ProductDetailAlternativeRow product={v} className={classes.itemRow} />
              </li>
            ))}
          </ul>
        ) : (
          <div className={classes.higlight}>{t('productDetailPage/alternativesNotFound')}</div>
        )}
      </div>
    );
  },
);

ProductDetailAlternatives.displayName = 'ProductDetailAlternatives';

export default withThemeProps(themeSettings)(ProductDetailAlternatives);
